import type { SVGProps } from "react";
export interface BabyCarriageIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BabyCarriageIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BabyCarriageIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 11c0-1-.264-2.187-.615-3.306l-.155-.474c-.43-1.263-1.7-2.095-3.195-2.095h-1.82c-1.495 0-2.765.832-3.194 2.095-.426 1.25-.771 2.637-.771 3.78a1.125 1.125 0 0 1-2.25 0c0-1.515.44-3.18.89-4.504l.165-.423c.905-2.058 3.011-3.198 5.16-3.198h1.82c2.292 0 4.535 1.297 5.324 3.621l.169.511c.385 1.226.722 2.667.722 3.994a1.125 1.125 0 0 1-2.25 0Z"
      />
      <path
        fill={color}
        d="M18.5 21.128a.62.62 0 0 0-.125.372l.012.126a.6.6 0 0 0 .113.245zm1 .743a.6.6 0 0 0 .112-.245l.013-.126-.013-.126a.6.6 0 0 0-.111-.246zm-10.888-.497a.6.6 0 0 0-.112-.247v.745a.6.6 0 0 0 .112-.246l.013-.126zM7.5 21.127a.62.62 0 0 0-.125.373l.013.126a.6.6 0 0 0 .112.246zM2.34.875a3.125 3.125 0 0 1 3.072 2.549l1.21 6.451H22a1.125 1.125 0 0 1 1.1 1.36l-.992 4.63a4.125 4.125 0 0 1-4.033 3.26H9.49a4.126 4.126 0 0 1-4.055-3.364L3.2 3.838a.875.875 0 0 0-.86-.713H2a1.125 1.125 0 0 1 0-2.25zm5.307 14.471.038.163a1.876 1.876 0 0 0 1.805 1.366h8.585c.884 0 1.647-.618 1.833-1.482l.7-3.268H7.043zM9.625 21.5a1.624 1.624 0 0 1-3.242.166l-.008-.166.008-.166A1.625 1.625 0 0 1 8 19.875l.166.008c.82.083 1.459.775 1.459 1.617m11 0a1.625 1.625 0 0 1-3.241.166l-.009-.166.009-.166A1.624 1.624 0 0 1 19 19.875l.166.008c.82.083 1.46.776 1.46 1.617Z"
      />
    </svg>
  );
}
